import Phaser from 'phaser';

import { ResizeMetrics } from '../../model/resize-metrics';
import { MiniChipViewModel } from './mini-chip-view-model';
import { Subscription } from 'rxjs';
import { BlackjackMainScene } from '../../scenes/blackjack-main-scene';

export class MiniChipView extends Phaser.GameObjects.Container {
  private currentResizeMetrics?: ResizeMetrics;
  private subscriptionGroup: Subscription;
  private miniSingleChip: Phaser.GameObjects.Image;
  private miniDoubleChip: Phaser.GameObjects.Image;

  constructor(
    scene: BlackjackMainScene,
    x: number,
    y: number,
    private viewModel: MiniChipViewModel,
  ) {
    super(scene, x, y);

    this.subscriptionGroup = new Subscription();

    this.miniSingleChip = scene.add
      .image(0, 0, viewModel.currentChipAsset.type)
      .setOrigin(0.5, 0.5);
    this.add(this.miniSingleChip);

    this.miniDoubleChip = scene.add
      .image(0, 0, viewModel.currentChipAsset.type)
      .setOrigin(0.5, 0.5);
    this.miniDoubleChip.setVisible(false);
    this.add(this.miniDoubleChip);

    this.setName(MiniChipView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      this.viewModel.chipAsset$.subscribe((asset) => {
        this.miniSingleChip.setTexture(asset.type);
        this.miniDoubleChip.setTexture(asset.type);
      }),
    );
    this.subscriptionGroup.add(
      this.viewModel.showDouble$.subscribe((showDouble) => {
        this.miniDoubleChip.setVisible(showDouble);
        this.refreshLayout(showDouble);
      }),
    );
  }

  override destroy(fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(fromScene);
  }

  public onResize(resizeMetrics: ResizeMetrics) {
    this.currentResizeMetrics = resizeMetrics;
    this.refreshLayout(this.viewModel.showDoubleNow);
  }

  public refreshLayout(showDouble: boolean) {
    if (!this.currentResizeMetrics) {
      return;
    }
    const scalingMetrics = this.currentResizeMetrics.scalingMetrics;

    const buttonScale = 0.2;
    const width =
      this.viewModel.currentChipAsset.dimensions.width * scalingMetrics.scaleFactor * buttonScale;
    const height =
      this.viewModel.currentChipAsset.dimensions.height * scalingMetrics.scaleFactor * buttonScale;

    this.miniSingleChip.setDisplaySize(width, height);
    this.miniDoubleChip.setDisplaySize(width, height);

    this.setSize(showDouble ? width * 1.5 : width, height);

    this.miniSingleChip.setX(showDouble ? this.miniDoubleChip.displayWidth * -0.25 : 0);
    this.miniDoubleChip.setX(showDouble ? this.miniSingleChip.displayWidth * 0.25 : 0);
  }
}
